export enum TargetAudienceEnum {
    Public = 1,
    Internal = 2,
    Vendor = 3
}
